import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { leonardSections, leonardTimelineData, heroData } from '../data/mockData';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const RememberingLeonardPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0b]">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-amber-500/5 via-transparent to-transparent" />
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-400 text-sm mb-4">March 26, 1931 — February 27, 2015</p>
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            <span className="text-white">Remembering </span>
            <span className="text-amber-500">Leonard Nimoy</span>
          </h1>
          <p className="text-gray-300 text-lg mb-8">
            Actor, Director, Photographer, Poet, and the man who gave us Mr. Spock
          </p>
          <p className="text-amber-500/80 italic text-base max-w-2xl mx-auto">
            "{heroData.quote}"
          </p>
        </div>
      </section>

      {/* Life Sections */}
      <section className="py-16 bg-[#0a0a0b]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {leonardSections.map((section, index) => (
            <div key={index} className="mb-16">
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0 text-4xl">🖖</div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-4">{section.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{section.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Vulcan Salute Section */}
      <section id="vulcan-salute" className="py-24 bg-[#0f0f12]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-6xl mb-8">🖖</div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Live Long and Prosper
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed mb-8">
            The Vulcan salute, created by Leonard Nimoy for Star Trek, was inspired by a Jewish blessing he witnessed as a child. The gesture and its accompanying phrase "Live Long and Prosper" have transcended entertainment to become a universal symbol of goodwill, used by people around the world — including astronauts in space.
          </p>
          <p className="text-amber-500 italic">
            "Peace and long life." — The traditional Vulcan response
          </p>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-24 bg-[#0a0a0b]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-amber-500 text-sm font-semibold tracking-widest uppercase">
              A Life in Service
            </span>
            <h2 className="text-4xl font-bold text-white mt-4">
              Key Moments
            </h2>
          </div>

          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-amber-500/30" />
            
            {leonardTimelineData.map((item, index) => (
              <div key={index} className="flex items-start mb-8 last:mb-0">
                <div className="flex-shrink-0 w-16 text-right">
                  <span className="text-amber-500 font-bold">{item.year}</span>
                </div>
                <div className="mx-6 w-4 h-4 bg-amber-500 rounded-full flex-shrink-0 mt-1 relative z-10" />
                <div className="flex-1">
                  <p className="text-white">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documentary CTA */}
      <section className="py-24 bg-[#0f0f12]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">
            Watch the Documentary
          </h2>
          <p className="text-gray-400 text-lg mb-10">
            Learn more about Leonard's extraordinary life and career in the documentary film.
          </p>
          <Link
            to="/film"
            className="inline-flex items-center gap-2 px-8 py-3 bg-amber-500 hover:bg-amber-600 text-black font-semibold rounded-full transition-all hover:scale-105"
          >
            Explore the Film
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RememberingLeonardPage;
